import React, { useEffect, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getItemDailyWeeklyMostView, getItemListSize, getProjectApi, getWriters, putProjectViewCount } from "../api";
import config from "../config";
import UserCard from "./UserCard";
import UserCardWrapper from "./UserCardWrapper";
import AuthorSlider from "./AuthorSlider";
import RandomArticleCard from "./RandomArticleCard";
import RandomImageCard from "./RandomImageCard";

const HomeSection = () => {

    const [data1, setData1] = useState([]);

    const [project, setProject] = useState({});
    const [writers, setWriters] = useState([]);
    const [dailyItems, setDailyItems] = useState([]);

    const getAPI = async()=>{


	const res1 =  getProjectApi(config.project.id);	
	const res2 =  getItemDailyWeeklyMostView();
	const res3 =  getItemListSize(6);
	const res4 =  getWriters();

	Promise.all([res1,res2,res3,res4]).then((sonuclar)=>{
        setData1(sonuclar[2].data);
        setProject(sonuclar[0].data);
        if(sonuclar[1]?.status && sonuclar[1]?.data?.daily) {
          setDailyItems(sonuclar[1].data.daily || []);
        }
        if(sonuclar[3]?.status) {
          setWriters(sonuclar[3].data || []);
        }

	})
    await putProjectViewCount({})

    }
    useEffect(() => {
      getAPI();
    }, [])




    return (
      <div className="home-sections">
        <Container>
          <div className="d-flex justify-content-between">
            <h2 className="title _set">ANSİKLOPEDİDE YENİ</h2>
            <Link className="seeAll" to="/maddeler">
              Tümü
            </Link>
          </div>
          <UserCardWrapper>
            <Row>
              {data1.map((item, i) => (
                <Col key={i} xs={6} className="px-3 px-md-5">
                  <UserCard info={item} />
                </Col>
              ))}
            </Row>
          </UserCardWrapper>

          <div className="view_count">
            Görüntülenme Sayısı: {project.viewCount?.toLocaleString()}
          </div>

          <AuthorSlider writers={writers} />

          <RandomArticleCard dailyItems={dailyItems} />

          <RandomImageCard />
        </Container>
      </div>
    );
}
export default HomeSection